import React, { Component } from 'react';
import { observer } from 'mobx-react';

import HistoryItem from './HistoryItem';

@observer class History extends Component {
  render() {
    const { history, contact } = this.props;

    return (
      <div>
        <h4>Historie</h4>
        
        <div className="list-group history">
          {history.map(h => <HistoryItem key={h.recId} item={h} contact={contact}/>) }

        </div>
      </div>
    );
  }
}

History.defaultProps = {
  history: []
};

export default History;



// WEBPACK FOOTER //
// ./src/history/History.js